import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '../services/analytics';

export function RouteAnalytics(): null {
  const location = useLocation();

  useEffect(() => {
    analytics.trackPageView();
  }, [location]);

  return null;
}
